export let DrawingMode;(function(E){E[E["FREEHAND_MODE"]=1]="FREEHAND_MODE";E[E["SINGLE_TAP_MODE"]=2]="SINGLE_TAP_MODE"})(DrawingMode||(DrawingMode={}));